import Segment from '../Segment';
import { SegmentData } from '../types/share';

const eventTypes = {
  shareSucceeded: 'ShareSucceeded',
  shareFailed: 'ShareFailed',
  shareCanceled: 'ShareCanceled',
};

function trackShareSucceeded(segmentData: SegmentData) {
  Segment.trackUserGot(eventTypes.shareSucceeded, segmentData);
}

function trackShareFailed(segmentData: SegmentData) {
  Segment.trackUserGot(eventTypes.shareFailed, segmentData);
}

function trackShareCanceled(segmentData: SegmentData) {
  Segment.trackUserGot(eventTypes.shareCanceled, segmentData);
}

export default {
  trackShareSucceeded,
  trackShareFailed,
  trackShareCanceled,
};
